/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import { useState, memo, useEffect } from "react";
import { message } from "antd";
import API from "../../../api";
import urls from "../../../api/urls";
import {
  camelCase,
  capitaliseWithHyphen,
  normalizeService,
} from "../../../utils";
import { maintenanceConfig } from "./../../../config/maintenance";

import moment from "moment";
import { useParams } from "react-router";
const useClientAndDepartment = (userInfo, form, formName = null) => {
  const { type } = useParams();
  const [loading, setLoading] = useState(false);
  const [pincodeLoading, setPincodeLoading] = useState(false);
  const [clientList, setClientList] = useState([]);
  const [department, setDepartment] = useState([]);
  // const [areaList, setAreaList] = useState([]);
  const [bookingDetails, setBookingDetails] = useState({});
  const [pinCodeServiceableStatus, setPinCodeServiceableStatus] = useState({});
  const [returnPinCodeServiceableStatus, setReturnPinCodeServiceableStatus] =
    useState({});
  const [senderPinCodeServiceableStatus, setSenderPinCodeServiceableStatus] =
    useState({ msg: null });

  const [contentDiscriptionData, setContentDiscriptionData] = useState({});
  const [clientDetails, setClientDetails] = useState(null);
  // const [setsubmitRespons, setSetsubmitRespons] = useState({});
  const [alertData, setAlertData] = useState(false);
  const [savedReturnAddressList, setSavedReturnAddressList] = useState([]);
  const [reviverNameAndAddress, setReviverNameAndAddress] = useState([]);
  const [reviverStateCity, setReviverStateCity] = useState(null);
  const [clientID, setClientID] = useState(null);
  const [editShipmentDetails, setEditShipmentDetails] = useState(null);
  const [mainEwayValidationStatus, setMainEwayValidationStatus] = useState({});
  const [editLoading, setEditLoading] = useState(false);

  const currentDate = moment();
  const currentEnv = process.env.REACT_APP_ENV;

  const todayDateNTimeFormat = currentDate.format("DD/MM/YYYY hh:mm:ss A");
  const transporterId = "88AABCM9407D1ZS"; // Hardcoded

  const [allEwayBills, setAllEwayBills] = useState([
    // {
    //   transMode: "Road",
    //   ewayBillNumber: "11111111111",
    //   name: "Amit",
    //   editable: true,
    //   expiryDate: "27/11/2024 11:59:00 PM",
    //   ewayBillCreateDate: "22/11/2024 02:10:00 PM",
    // },
  ]);

  const [newDataFormat, setNewDataFormat] = useState({});
  const {
    GET_CLIENT_LIST,
    GET_DEPARTMENT_LIST,
    GET_SINGLE_BOOKING,
    GET_NBA_SINGLE_BOOKING,
    CHECK_PIN_CODE_SERVICEABILITY,
    GET_CONTENTDISCRIPTIN_LIST,
    GET_DESTINATION_PREMISE_ID,
    POST_CREDIT_DATA,
    EWAYBILL,
    ADDRESS_PINCODE,
    DELCAPER_PINCODE_SERVICE,
    RETURN_ADDRESS,
    GET_RECIVER_NAME_ADDRESS,
    BOOKING_BARCODE_VALIDATION,
    VALIDATE_DOCUMENT_NUMBER,
    GET_CLIENT_INNO,
    GET_CLIENT_INNO_V2,
    GET_CLIENT_LIST_NEW,
    FETCH_CLIENT_RATE_EDIT,
    GET_CLIENT_LIST_NEW_NBA_QA,
    GET_DEPARTMENT_LIST_NBA,
  } = urls;

  function containsAllPairs(obj, array) {
    // console.log(obj, array, "arr");

    for (let item of array) {
      if (
        +item?.mobileNumber === +obj?.mobileNumber &&
        item?.name === obj?.name
      ) {
        return {
          receiverDetails: [
            {
              userId: item?.userId,
              mobileNumber: obj?.mobileNumber,
              emailAddress: obj?.emailAddress,
              address: obj?.address,
              name: obj?.name,
              bookingType: obj?.bookingType,
              addressType: item?.addressType,
              createdDate: item?.createdDate,
            },
          ],
        };
      }
    }

    return { receiverDetails: [{ ...obj, userId: null }] };
  }

  const getClients = async (companyId) => {
    setLoading(true);
    let res;
    if (currentEnv === "qa") {
      res = await API.Api(
        GET_CLIENT_LIST_NEW_NBA_QA + `?companyId=${companyId}`
      ).getWithPremiseHeader();
    } else {
      res = await API.Api(GET_CLIENT_INNO).getwithParams({
        company_id: companyId,
      });
    }

    if (res.status) {
      const response = res?.response?.data?.data || [];
      let clients;

      if (currentEnv === "qa") {
        clients = response?.map((e, i) => ({
          key: i,
          label: e?.orgName?.toUpperCase(),
          value: e?.metadata?.find((item) => item.key === "CLIENT_LOCATION_ID")
            ?.value,
          department: [e?.businessDetail],
          clientSevaId: e?.metadata?.find(
            (item) => item.key === "SEVASETU_CLIENT_ID"
          )?.value,
        }));
      } else {
        clients = response?.map((e, i) => ({
          key: i,
          label: e?.ClientName?.toUpperCase(),
          value: e?.ClientName,
          department: e?.Departments,
          // clientSevaId: e?.metadata[0]?.value,
        }));
      }
      localStorage.setItem("allClients", JSON.stringify(clients) || null);
      setClientList(clients);
      setLoading(false);
    } else {
      message.error(
        res?.response?.data?.message || "Clinet list fetching error"
      );
      setLoading(false);
    }
  };

  const getDepartMentQA = async (selectedClient) => {
    form.setFieldsValue({
      department: null,
      documentNumber: null,
      receiverAddress: null,
      mobileNumber: null,
      receiverEmail: null,
    });

    const currentDepartment = selectedClient?.department || [];

    // if (selectedClient) {
    //   setDepartment(
    //     selectedClient?.department?.map((item, i) => ({
    //       key: i,
    //       value: i,
    //       label: getDepartmentContactName(item),
    //       item: item,
    //     }))
    //   );
    // }

    if (currentDepartment?.length == 1) {
      const item = currentDepartment[0];
      const mergeName = getDepartmentContactName(item);

      form.setFieldsValue({
        department: mergeName,
      });
      setLoading(true);

      let res = await API.Api(
        GET_DEPARTMENT_LIST_NBA + selectedClient?.value
      ).getCustomHeader();

      if (res?.status) {
        const clientOrganizationDetails = res?.response?.data;

        const clientOnboard = res?.response?.data?.clientOnboard;
        // getReturnAddressList(item?.ClientID);

        setClientDetails({
          clientId: selectedClient?.value || null,
          clientName: selectedClient?.label || null,
          clientSevaId: +selectedClient?.clientSevaId || null,
        });

        let addressData = clientOrganizationDetails?.addresses[0];
        let contactData = clientOrganizationDetails?.contacts[0];

        const addressDetails = {
          senderName: clientOrganizationDetails?.orgName || null,

          senderAddressLine1: addressData?.street || null,
          senderAddressLine2: addressData?.street || "",
          senderPincode: addressData?.pincode || null,
          senderState: addressData?.state || null,
          senderCity: addressData?.city || null,
          senderMobileNumber: contactData?.number || "",
          senderEmail: clientOnboard?.emailId || null,
          senderGst: clientOnboard?.gstin || null,
          areaName: addressData?.area || null,
        };

        setLoading(false);

        setBookingDetails((prevState) => ({
          ...prevState,
          addressDetails,
          clientId: clientOrganizationDetails?.clientId,
        }));
      } else {
        setBookingDetails({});
        setClientID(null);
        message.error(
          res?.response?.data?.message || "Client details fetch error"
        );
        setLoading(false);
      }
    }
  };

  const getRecvNameAddressList = async (type) => {
    setLoading(true);
    let res = await API.Api(GET_RECIVER_NAME_ADDRESS + type).getCustomHeader({
      "PREMISE-ID": userInfo?.premiseId,
    });
    if (res.status) {
      const response = res?.response?.data;
      setReviverNameAndAddress(response);
      setLoading(false);
    } else {
      message.error("Something went wrong");
      setLoading(false);
    }
  };

  const getContentDiscriptionData = async () => {
    setLoading(true);
    let res = await API.Api(GET_CONTENTDISCRIPTIN_LIST).getCustomHeader({
      cpId: userInfo?.premiseId,
    });
    if (res.status) {
      setLoading(false);
      const response = res?.response?.data;
      setContentDiscriptionData(response);
      localStorage.setItem("content", JSON.stringify(response) || null);
    } else {
      message.error("Something went wrong");
      setLoading(false);
    }
  };

  const getDepartmentContactName = (item) => {
    let departmentName =
      item?.Department && item?.Department !== ""
        ? item?.Department
        : "Default";

    let contactName =
      item?.ContactPerson && item?.ContactPerson !== ""
        ? "-" + item?.ContactPerson
        : "";

    if (contactName !== "" && departmentName === "Default") {
      departmentName = "";
      contactName =
        item?.ContactPerson && item?.ContactPerson !== ""
          ? item?.ContactPerson
          : "";
    }

    return departmentName + contactName;
  };

  const getClientDetails = async (item, selectedClient) => {
    setLoading(true);
    try {
      let response = await API.Api(
        `${GET_CLIENT_INNO}${item?.ClientID}`
      ).getWithHeader();

      if (response?.status) {
        const details = response?.response?.data?.data || {};

        // Call only if ClientID is valid
        // if (item?.ClientID) {
        //   getReturnAddressList(item?.ClientID);
        // }

        setClientDetails({
          clientId: item?.ClientID,
          clientName: selectedClient?.value || details?.ClientName,
        });

        const addressDetails = {
          senderName: details?.ClientName || null,
          senderAddressLine2: details?.Address2 || "",

          senderAddressLine1: details?.Address1 || null, //Req
          senderPincode: details?.Pincode || null, //Req
          senderState: details?.StateName || null, //Req
          senderCity: details?.City || null, //Req

          senderMobileNumber: details?.Mobile || null,
          senderEmail: details?.Email || null,
          senderGst: details?.Gstin || null,
          areaName: details?.City || null,
        };

        if (
          !details?.Address1 ||
          !details?.Pincode ||
          !details?.StateName ||
          !details?.City
        ) {
          setBookingDetails({});
          setClientID(null);
          message.error("Client details fetch error, try again.");
          return;
        }

        setBookingDetails((prevState) => ({
          ...prevState,
          addressDetails,
          clientId: item?.ClientID || null,
        }));

        setClientID(item?.ClientID);
      } else {
        throw new Error(
          response?.response?.data?.message || "Internal server error"
        );
      }
    } catch (error) {
      setBookingDetails({});
      setClientID(null);
      message.error(error?.message || "Client error");
    } finally {
      setLoading(false);
    }
  };

  const setClientDepartment = (selectedClient, selectedDepartment) => {
    if (type !== "OCR" && type !== "API") {
      form.setFieldsValue({
        // department: null,
        documentNumber: null,
        service: "STANDARD",
      });
    }

    const currentDepartment = selectedDepartment
      ? [selectedDepartment?.item]
      : selectedClient?.department || [];

    if (selectedClient) {
      form.setFieldsValue({
        department: null,
      });
      setDepartment(
        selectedClient?.department?.map((item, i) => ({
          key: i,
          value: i,
          label: getDepartmentContactName(item),
          item: item,
        }))
      );
    }

    if (currentDepartment?.length === 1) {
      const item = currentDepartment[0];

      if (!item?.ClientID) {
        message.error("Client details fetch error(ID)");
        return;
      }

      const mergeName = getDepartmentContactName(item);

      form.setFieldsValue({
        department: mergeName,
      });

      // Check if selectedDepartment exists and has the same ClientID
      if (
        selectedDepartment &&
        clientDetails &&
        clientDetails?.clientId == selectedDepartment?.item?.ClientID
      ) {
        return;
      }

      getClientDetails(item, selectedClient);
    }
  };

  const setEditClientDepartment = async (selectedClientId) => {
    // console.log(selectedClient, "selectedClient");

    setLoading(true);

    let response = await API.Api(
      `${GET_CLIENT_INNO_V2}${selectedClientId}`
    ).getWithHeader();

    if (response?.status) {
      setLoading(false);

      const details = response?.response?.data?.data || {};

      form.setFieldsValue({
        department: details?.ContactPerson || "NA",
      });
    } else {
      form.setFieldsValue({
        department: "NA",
      });
      setLoading(false);
      // message.error(
      //   response?.response?.data?.message || "Internal server error"
      // );
    }
  };
  const getReturnDeliveryPincode = async (e, editId) => {
    if (editId) {
      setEditLoading(true);
    }

    const value = e?.target ? e?.target?.value : e;

    handlePincodeServiceability(
      value,
      setReturnPinCodeServiceableStatus,
      (loading) => setLoading(loading),
      null
    );
  };

  const handlePincodeServiceability = async (
    value,
    setServiceableStatus,
    setLoadingState,
    formFieldName,
    additionalStateUpdater = () => {},
    serviceType
  ) => {
    setServiceableStatus({
      serviceability: null,
      status: null,
      msg: null,
      stateCode: null,
      city: null,
      pincode: null,
      districtIp: null,
      state: null,
    });

    if (String(value)?.length > 5) {
      setLoadingState(true);
      let getFromPincode = JSON.parse(localStorage.getItem("userId"));

      try {
        const response = await API.Api(DELCAPER_PINCODE_SERVICE).post({
          fromPincode: getFromPincode?.premises?.pincode || null,
          toPincode: +value,
        });

        if (response?.status) {
          const res = response?.response?.data?.data?.pincodeData;
          const serviceability = response?.response?.data?.data?.serviceable;
          let status = serviceability ? "success" : "error";
          let msg = serviceability ? null : "Non-Serviceable";

          if (!res.city || !res.stateName) {
            console.log(res, "res");
            status = "error";
            msg = "City or State is null";
            setServiceableStatus({
              serviceability,
              status,
              msg,
              stateCode: res?.stateCode,
              city: res?.city,
              state: res?.stateName,
              pincode: res?.pincode || value,
            });
          }

          setServiceableStatus({
            serviceability,
            status,
            msg,
            stateCode: res?.stateCode,
            city: res?.city,
            state: res?.stateName,
            pincode: res?.pincode || value,
            districtIp: res?.districtIp || "",
          });

          if (formFieldName) {
            form.setFieldsValue({ [formFieldName]: res?.pincode || value });
          }

          if (
            serviceType == "FAST TRACK" ||
            serviceType == "vayuquick" ||
            serviceType == "vayuquick_pro"
          ) {
            form.setFieldsValue({
              service: "FAST TRACK",
            });
            const newOptions =
              response?.response?.data?.data?.availableServices
                ?.filter((item) => item?.serviceable)
                .sort((a, b) => {
                  // Prioritize vayuquick_pro over vayuquick
                  const priority = ["vayuquick_pro", "vayuquick"];
                  return (
                    priority.indexOf(a?.serviceName) -
                    priority.indexOf(b?.serviceName)
                  );
                })
                ?.map((item) => ({
                  value: item?.serviceName,
                  label: normalizeService(item?.serviceName)?.toUpperCase(),
                })) || [];

            const temp = [{ value: "FAST TRACK", label: "FAST TRACK" }];
            setServiceOptions((prev) => [...temp, ...newOptions]);
          }

          additionalStateUpdater({
            city: res?.city,
            state: res?.stateName,
          });
        } else {
          if (response?.response?.data?.status === 400) {
            setServiceableStatus({
              serviceability: null,
              status: "error",
              msg: "Non-Serviceable",
              stateCode: null,
              city: null,
              pincode: null,
              districtIp: null,
              state: null,
            });
            return;
          }
          setServiceableStatus({
            serviceability: null,
            status: "error",
            msg: response?.response?.data?.message,
            stateCode: null,
            city: null,
            pincode: null,
            districtIp: null,
            state: null,
          });
        }
      } catch (error) {
        console.error("Error fetching pincode details:", error);
        setServiceableStatus({
          serviceability: null,
          status: "error",
          msg: "An error occurred. Please try again.",
          stateCode: null,
          city: null,
          pincode: null,
          districtIp: null,
          state: null,
        });
      } finally {
        setLoadingState(false);
      }
    }
  };

  const getDeliveryPincode = (e, editId, serviceType, check = false) => {
    const value = e?.target ? e?.target?.value : e;

    if (editId) {
      setEditLoading(true);
    }
    if (+value == +pinCodeServiceableStatus?.pincode && !check) {
      return;
    }

    handlePincodeServiceability(
      value,
      setPinCodeServiceableStatus,
      (loading) => {
        setPincodeLoading(loading);
        setEditLoading(loading);
      },
      "deliveryPincode",
      (state) => setReviverStateCity(state),
      serviceType
    );
  };

  const getSenderPincode = (e, edit, serviceType) => {
    const value = e?.target ? e?.target?.value : e;

    handlePincodeServiceability(
      value,
      setSenderPinCodeServiceableStatus,
      (loading) => setPincodeLoading(loading),
      null,
      () => {},
      serviceType
    );
  };

  // console.log(reviverStateCity, "Main reviverStateCity");

  const checkAWBDocUsed = (awb, bookType, shipmentType) => {
    form.setFields([
      {
        name: "documentNumber",
        errors: null,
      },
    ]);
  };

  const submitWithPostDetails = async (payload, companyId) => {
    setLoading(true);

    // const company_id =
    //   JSON.parse(localStorage.getItem("selectedCompany"))?.key || null;

    let response = await API.Api(POST_CREDIT_DATA).postIdCustomHeader(payload, {
      company_id: companyId,
    });

    if (response?.status) {
      setLoading(false);
      if (
        maintenanceConfig?.isActive &&
        !maintenanceConfig?.testUsers?.includes(
          JSON.parse(localStorage.getItem("userinfo"))?.spId
        )
      ) {
        localStorage.clear();
        window.location.assign("/");
        document.cookie = "userToken=";
        localStorage.clear();
      }
      return response;
    } else {
      setLoading(false);
      if (
        maintenanceConfig?.isActive &&
        !maintenanceConfig?.testUsers?.includes(
          JSON.parse(localStorage.getItem("userinfo"))?.spId
        )
      ) {
        localStorage.clear();
        window.location.assign("/");
        document.cookie = "userToken=";
        localStorage.clear();
      }
      return response;
    }
  };

  // console.log(parentEwayBill, "paren");

  const documentValidate = async (documentNumber, bookingType, service) => {
    const serviceLower = service?.toLowerCase();
    const spId = JSON.parse(localStorage.getItem("userinfo"))?.spId || null;
    const clientLoginId =
      JSON.parse(localStorage.getItem("userinfo"))?.clientId || null;

    let payload = {
      bookingType: bookingType,
      subBookingType: serviceLower?.includes("fast")
        ? "FastTrack"
        : serviceLower == "childbadgecourier"
        ? "ChildBadgeCourier"
        : serviceLower?.includes("standard")
        ? "Standard"
        : serviceLower?.includes("value")
        ? "ValuePlus"
        : null,

      spId: spId,
      documentNumber: documentNumber,
    };

    if (bookingType == "Account") {
      payload.clientId = clientDetails?.clientId || clientLoginId;
    }

    try {
      let response = await API.Api(VALIDATE_DOCUMENT_NUMBER).getwithParams(
        payload
      );
      return response;
    } catch (error) {
      message.error(error?.message || "Internal server errror");
      // console.error("Error during validation:", error);
    }
  };

  const getReturnAddressList = async (id) => {
    // setLoading(true);
    let res = await API.Api(RETURN_ADDRESS + id).getWithHeader();
    if (res?.status) {
      setLoading(false);

      let data = res?.response?.data;
      let temp = data?.map((item, i) => ({
        ...item,
        isAddressEnabled: i === 0,
      }));
      setSavedReturnAddressList(temp);
      // setReturnAddress(temp);
    } else {
      setLoading(false);

      setSavedReturnAddressList([]);
      message.error(
        res?.response?.data?.message || "Can't fetch return address."
      );
    }
  };

  const updateReturnAddressList = (value) => {
    setSavedReturnAddressList(value);
  };

  // const resetCredit = () => {
  //   setPinCodeServiceableStatus({});
  //   // setAreaList([]);
  // };

  function handleTabEnter(event, temp) {
    // const tabbableElements = Array.from(
    //   document.querySelectorAll("input, button, select, textarea, a[href]")
    // )?.filter((el) => !el?.disabled && el?.offsetParent !== null);

    // const currentIndex = tabbableElements?.indexOf(document?.activeElement);

    // let nextIndex;
    // let prevIndex;

    // if (event?.shiftKey) {
    //   prevIndex = (currentIndex - 1) % tabbableElements.length;

    //   tabbableElements[prevIndex]?.focus();
    //   tabbableElements[prevIndex]?.select();
    // } else {
    //   nextIndex = (currentIndex + 1) % tabbableElements.length;

    //   tabbableElements[nextIndex]?.focus();
    //   tabbableElements[nextIndex]?.select();
    // }
    if (event?.target?.id == "weight") {
      let value = event?.target?.value;

      if (value[0] == ".") {
        form.setFieldsValue({ weight: 0 + value });
      }
    }

    const tabbableElements = Array.from(
      document.querySelectorAll("input, button, select, textarea, a[href]")
    )?.filter((el) => !el?.disabled && el?.offsetParent !== null);

    const currentIndex = tabbableElements?.indexOf(document?.activeElement);

    const nextIndex = (currentIndex + 1) % tabbableElements?.length;

    tabbableElements[nextIndex]?.focus();
    tabbableElements[nextIndex]?.select();
  }
  const handleOnEnter = (event, next) => {
    event?.preventDefault();
    const targetElement = event?.target;
    let currentValue = targetElement?.value?.trim();

    const errMsg = {
      deliveryPincode: "Enter Pincode",
      documentNumber: "Enter Document Number",
      mobileNumber: "Enter Mobile Number",
      senderName: "Enter sender name",
      senderMobileNumber: "Enter mobile number",
      kycDocumentNo: "Enter KYC number",
      freight: "Enter freight",
      // length: "Enter lenght",
      // height: "Enter height",
      // width: "Enter width",
    };

    if (!currentValue && targetElement?.id in errMsg) {
      setTimeout(() => {
        if (!currentValue) {
          form.setFields([
            {
              name: targetElement?.id.toString(),
              errors: [errMsg[targetElement.id]],
            },
          ]);
        }
      }, 0);
      return;
    }

    const allowEmptyIds = [
      "clientName",
      "shipmentType",
      "service",
      "travelBy",
      "department",
      "ewayBill0",
      "receiverEmail",
      "senderEmail",
      "submit_credit",
      "kycType",
      "gst",
      "pan",
      "aadhar",
      "paymentMode",
      "IsSez",
      "insured",
      "senderGST",
      "kycDocumentType",
      "length",
      "width",
      "height",
      "discountBooking",
    ];

    if (allowEmptyIds.includes(targetElement?.id)) {
      handleTabEnter(event);
      return;
    }

    if (currentValue) {
      handleTabEnter(event);
      return;
    }
  };

  const [servicesOptions, setServiceOptions] = useState([
    {
      value: "STANDARD",
      label: "STANDARD",
    },
    {
      value: "FAST TRACK",
      label: "FAST TRACK",
    },
    { value: "VALUE PLUS", label: "VALUE PLUS" },
  ]);

  const travelByOptions = [
    {
      value: "SURFACE",
      label: "SURFACE",
    },
    {
      value: "AIR",
      label: "AIR",
    },
  ];

  const insuredOptions = [
    {
      value: "NO",
      label: "NO",
    },
    {
      value: "YES",
      label: "YES",
    },
  ];

  const getSingleShipmentDetails = async (cliendID, date) => {
    setLoading(true);
    let res;
    if (date) {
      res = await API.Api(
        GET_SINGLE_BOOKING + `${cliendID}?` + `${date}`
      ).getWithHeader();
    } else {
      res = await API.Api(GET_SINGLE_BOOKING + cliendID).getWithHeader();
    }

    if (res?.status) {
      setLoading(false);

      setEditShipmentDetails(res?.response?.data);
      // setReturnAddress(temp);
    } else {
      setEditShipmentDetails(null);
      setLoading(false);
      message.error(res?.response?.data?.message || "Internal server error");
    }
  };

  const getNBASingleShipmentDetails = async (cliendID) => {
    setLoading(true);
    let res = await API.Api(GET_NBA_SINGLE_BOOKING + cliendID).getWithHeader();

    if (res?.status) {
      setLoading(false);

      setEditShipmentDetails(res?.response?.data?.data);
      // setReturnAddress(temp);
    } else {
      setEditShipmentDetails(null);
      setLoading(false);
      message.error(res?.response?.data?.message || "Internal server error");
    }
  };

  const eWayBillHandle = async (value) => {
    if (value?.length < 12 && value.length !== 0) {
      setMainEwayValidationStatus({
        status: "error",
        msg: "Enter valid Eway bill",
      });
      let temp = [...allEwayBills]?.filter((val) => val?.editable == true);
      setAllEwayBills(temp);
    }
    if (value?.length === 12) {
      setLoading(true);
      const response = await API.Api(
        EWAYBILL + "/" + value
      ).getWithPremiseIdHeader();

      if (response?.status) {
        setLoading(false);
        // handleLoader(false);
        const checkStatus = response?.response?.data?.status;

        if (checkStatus == "0") {
          setMainEwayValidationStatus({
            status: "error",
            msg: "Enter valid Eway bill",
          });
          return;
        }

        if (checkStatus == "1") {
          try {
            const data = JSON.parse(response?.response?.data?.data);
            const validilityDate = moment(data?.validUpto, "DD/MM/YYYY");
            const todayDateNTime = moment(todayDateNTimeFormat, "DD/MM/YYYY");
            if (todayDateNTime.isAfter(validilityDate)) {
              setMainEwayValidationStatus({
                status: "error",
                msg: "E-way bill expired",
              });
              return;
            } else if (data?.transporterId !== transporterId) {
              setMainEwayValidationStatus({
                status: "error",
                msg: "Transporter id is not matching",
              });
              return;
            } else {
              setMainEwayValidationStatus({
                status: "success",
                msg: null,
              });
              const isDuplicate = allEwayBills?.some(
                (item) => item?.ewayBillNumber == value
              );

              if (!isDuplicate) {
                setAllEwayBills((prevItems) => {
                  const updatedItems = [
                    ...prevItems,
                    {
                      transMode: "Road",
                      ewayBillNumber: data?.ewbNo.toString(),
                      name: value?.name,
                      editable: false,
                      expiryDate: data?.validUpto,
                      ewayBillCreateDate: data?.ewayBillDate,
                    },
                  ];

                  return updatedItems;
                });
              }
              message.success("E-way bill request succeeds");
            }
          } catch (error) {
            setMainEwayValidationStatus({
              status: "error",
              msg: "Not able to verify this Eway bill for now",
            });
          }
        }
      } else {
        setLoading(false);
        setMainEwayValidationStatus({
          status: "error",
          msg: "Enter valid Eway bill",
        });
      }
    }
  };

  const getClientEditRates = async (awbNum) => {
    setLoading(true);

    let response = await API.Api(
      `${FETCH_CLIENT_RATE_EDIT}/sevasetu-reader/shipment/${awbNum}
`
    ).getWithNoToken();

    if (response?.status) {
      setLoading(false);

      const temp = response?.response?.data?.data?.charges;
      return temp;
    } else {
      setLoading(false);
      return 0;
    }
  };

  const [allPincodes, setAllPincodes] = useState([]);

  const doxandNonDoxChange = {
    content: null,
    description: null,
    weight: "1",
    length: 0,
    width: 0,
    height: 0,
    totalVolWeight: 0,
    volumetricWeight: "0.00",
    child_Selected: false,
    value: null,
  };

  useEffect(() => {
    const userInfo = localStorage.getItem("userinfo");
    const parsedUserInfo = JSON.parse(userInfo);
    if (userInfo) {
      try {
        if (parsedUserInfo?.state?.toUpperCase()?.trim() != "GUJARAT") {
          setServiceOptions((prevOptions) =>
            prevOptions?.filter((option) => option.value !== "VALUE PLUS")
          );
        }
      } catch (error) {
        console.log("FAILED TO PARSE USERINFO");
      }
    }
  }, []);

  useEffect(() => {
    try {
      const jsonData = JSON?.parse(localStorage?.getItem("allPincodes"));
      setAllPincodes(jsonData);
    } catch (error) {
      console.error("Invalid JSON:", error);
    }
  }, []);

  return {
    travelByOptions,
    insuredOptions,
    servicesOptions,
    loading,
    eWayBillHandle,
    clientList,
    department,

    getClients,

    setClientDepartment,
    setEditClientDepartment,
    setPinCodeServiceableStatus,
    handleOnEnter,
    containsAllPairs,
    getDeliveryPincode,
    getSingleShipmentDetails,

    editShipmentDetails,
    pinCodeServiceableStatus,
    returnPinCodeServiceableStatus,
    setReturnPinCodeServiceableStatus,
    // areaList,
    bookingDetails,
    getContentDiscriptionData,
    getDepartMentQA,
    contentDiscriptionData,

    clientDetails,
    submitWithPostDetails,
    // setsubmitRespons,
    setAlertData,
    allEwayBills,
    setAllEwayBills,
    alertData,
    savedReturnAddressList,
    setSavedReturnAddressList,
    updateReturnAddressList,
    getRecvNameAddressList,
    reviverNameAndAddress,
    reviverStateCity,
    // resetCredit,
    checkAWBDocUsed,
    setReviverStateCity,
    // getReturnAddressList,
    documentValidate,
    clientID,
    setClientID,
    setLoading,
    mainEwayValidationStatus,
    setEditLoading,
    editLoading,
    setMainEwayValidationStatus,
    getReturnDeliveryPincode,
    setDepartment,
    getSenderPincode,
    setSenderPinCodeServiceableStatus,
    senderPinCodeServiceableStatus,
    setServiceOptions,
    handleTabEnter,

    getClientEditRates,

    doxandNonDoxChange,
    allPincodes,
    getNBASingleShipmentDetails,
    pincodeLoading,
    setEditShipmentDetails,
    newDataFormat,
    setNewDataFormat,
  };
};

export default useClientAndDepartment;
